import { useTranslation } from 'react-i18next'

import InfoModal from '../../../common/InfoModal'
import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'

const EditDisabledModal = (props) => {
  const { t } = useTranslation()

  return (
    <InfoModal
      title={t('communitySettings.pricing.editDisabledModal.title')}
      icon={<WarningIcon />}
      buttonMessage={t('communitySettings.pricing.editDisabledModal.gotIt')}
      {...props}
    >
      <div>
        <p>{t('communitySettings.pricing.editDisabledModal.intro')}</p>
        <h5 className='font-weight-bold'>{t('communitySettings.pricing.editDisabledModal.whatToDo')}</h5>
        <p>{t('communitySettings.pricing.editDisabledModal.recommendation')}</p>
      </div>
    </InfoModal>
  )
}

export default EditDisabledModal
